import { createSelector } from 'reselect';
 
const selectEvents = (state: any) => state.events;


export const selectEventsCurrentItem = createSelector([selectEvents], (events) => events.current);

export const selectEventsListItems = createSelector([selectEvents], (events) => events.list);

export const selectEventsQueryItems = createSelector([selectEvents], (events) => events.query);

export const selectEventsPublishedItem = createSelector([selectEvents], (events) => events.publish);

export const selectEventsItemById = (itemId: any) =>
    createSelector(selectEventsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectEventsCreatedItem = createSelector([selectEvents], (events) => events.create);

export const selectEventsUpdatedItem = createSelector([selectEvents], (events) => events.update);

export const selectEventsReadItem = createSelector([selectEvents], (events) => events.read);

export const selectEventsDeletedItem = createSelector([selectEvents], (events) => events.delete);

export const selectEventsSearchedItems = createSelector([selectEvents], (events) => events.search);

export const selectEventsItemsCount = createSelector([selectEvents], (events) => events.count);

export const selectEventsItemsFilter = createSelector([selectEvents], (events) => events.filter);